
/* Constants ==================================================================================== */
import {
  HEADER,
  NAVBAR,
  TOOLBAR,
  TOPBAR,
} from '../../../components/app-layout/app-layout.constants'

/* Common ======================================================================================= */
import config from '../../../../config'

/* Components =================================================================================== */
import '../../modals/access-manager'
import '../../modals/field-edit'
import '../../modals/contact-us'
import '../../modals/password-change'
import '../../modals/request'
import '../../modals/portal'
import { AppLayoutClass } from '../../../components/app-layout'
import { Header } from '../../../modules/layouts/header'
import { Navbar } from '../../../modules/layouts/navbar'
import { Toolbar } from '../../../modules/layouts/toolbar'
import { Topbar } from '../../../modules/layouts/topbar'

/* App Layout Init ============================================================================== */
const AppLayout = new AppLayoutClass({ id: 'internal-app' })

AppLayout.setConfig({
  topbar: {
    active: false,
  },
  navbar: {
    active: true,
  },
  toolbar: {
    active: true,
  },
})

/* App Layout Components ======================================================================== */
AppLayout.setComponent(HEADER, Header)
AppLayout.setComponent(NAVBAR, Navbar)
AppLayout.setComponent(TOOLBAR, Toolbar)
AppLayout.setComponent(TOPBAR, Topbar)
AppLayout.setProps(HEADER, { maxWidth: '100%', ...config.app.headerProps })
AppLayout.setProps(NAVBAR, { maxWidth: '100%', ...config.app.navbarProps })

export default AppLayout
